'use client';

import HeroSectionImages from './hero-images';
import HeroSectionText from './hero-text';
const HeroSection = () => {
  return <div className='relative grid grid-cols-1 gap-5.5 lg:grid-cols-3' data-sentry-component="HeroSection" data-sentry-source-file="index.tsx">
            <HeroSectionText data-sentry-element="HeroSectionText" data-sentry-source-file="index.tsx" />
            <HeroSectionImages data-sentry-element="HeroSectionImages" data-sentry-source-file="index.tsx" />
        </div>;
};
export default HeroSection;